import React, { ReactNode } from "react";
import styled from "styled-components";

interface IListProps {
  bg?: string;
  pd?: string;
  itemPd?: string;
  lastBd?: boolean;
  children: ReactNode;
}

const List = (props: IListProps) => {
  return (
    <ListSet bg={props.bg} pd={props.pd} itemPd={props.itemPd} lastBd={props.lastBd}>
      {props.children}
    </ListSet>
  );
};

const ListSet = styled.ul<IListProps>`
  padding: ${(props) => props.pd || "15px"};
  background-color: ${(props) => props.bg};
  > li {
    padding: ${(props) => props.itemPd || "0"};
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    &.disabled {
      > * {
        opacity: 50%;
      }
    }
    &:last-child {
      border-bottom: ${(props) => (props.lastBd ? "1px solid ${({theme}) => theme.color.linePrimary}" : "none")};
    }
  }
`;

export default List;
